import { Component, HostListener, OnInit } from '@angular/core';
import { ThemeService } from './shared/services/theme.service';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private themeService: ThemeService,
    private store: Store,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      const urlTheme = this.themeService.getThemeNameFromParam(params['theme']);
      this.themeService.applyThemeByName(urlTheme);

      if (params['theme']) {
        sessionStorage.setItem('urlThemeRequested', urlTheme);
        const queryParams = { ...params };
        delete queryParams['theme'];
        this.router.navigate([], {
          queryParams,
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });
      }
    });

    this.store.dispatch({ type: '[App] Init' });
  }

  prepareRoute(outlet: any) {
    return (
      outlet &&
      outlet.activatedRouteData &&
      outlet.activatedRouteData['animation']
    );
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    const scrolled = window.scrollY;
    if (scrolled > 10) {
      document
        .querySelector('meta[name="theme-color"]')
        ?.setAttribute('content', '#ffd42f');
    } else {
      document
        .querySelector('meta[name="theme-color"]')
        ?.setAttribute('content', '#ffd42f');
    }
  }
}
